import React from "react";
import First from "../icons/first.png";

const PersonalDetailStepIcon = () => (
  <div className="WH32">
    <img src={First} alt="Default Icon" />
  </div>
);

export default PersonalDetailStepIcon;
